<div
    class="h-auto py-2 flex flex-wrap justify-between items-center gap-3 pl-2"
    [class.flex-col]="isFlexCol()"
    [class.flex-row]="!isFlexCol()">
    <div
        class="flex items-center gap-4"
        [class.w-full]="isFlexCol()">
        <div class="flex flex-wrap items-center gap-2 flex-1 min-w-0">
            <app-paginator
                #paginator
                [page]="paginationParameters().page"
                [take]="paginationParameters().take"
                [totalItems]="paginationParameters().totalItems ?? 0"
                (onPageChange)="onPageChange.emit($event)" />

            @if (canSearch()) {
                <app-search
                    labelKey="businessIdentifier"
                    [dense]="true"
                    [disabled]="searchDisabled()"
                    [hasDebounce]="true"
                    [(forceReset)]="forceReset"
                    (searchValue)="handleSearch.emit($event)" />
            }

            @if (totalEntities() !== undefined && isFlexCol()) {
                <span class="text-body-2 text-custom-dark-grey font-normal block ml-2">
                    {{ totalEntities() }} {{ 'element' | transloco: { COUNT: totalEntities() } }}
                </span>
            }
        </div>
    </div>

    <div
        class="flex flex-row justify-center items-center gap-2"
        [class.w-full]="isFlexCol()">
        <div class="flex flex-row items-center gap-3 justify-around grow">
            @if (selectedLayerNumber() !== undefined) {
                <span class="text-body-2 text-custom-dark-grey font-normal w-fit whitespace-pre-line text-left">
                    {{ selectedLayerNumber() }}
                    {{ 'selectedLayer' | transloco: { COUNT: selectedLayerNumber() } }}
                </span>
            }
            @if (selectedEntitiesNumber() !== undefined) {
                <span class="text-body-2 text-custom-dark-grey font-normal w-fit whitespace-pre-line text-left"
                    >{{ selectedEntitiesNumber() }}
                    {{ 'selectedEntity' | transloco: { COUNT: selectedEntitiesNumber() } }}</span
                >
            }
        </div>

        @if (totalEntities() !== undefined && !isFlexCol()) {
            <span class="text-body-2 text-custom-dark-grey font-normal"
                >{{ totalEntities() }} {{ 'element' | transloco: { COUNT: totalEntities() } }}</span
            >
        }

        <ng-content />
    </div>
</div>
